import { IStandardCareProposal } from '@alberta/konexi-shared';
import { Inject, Injectable } from '@angular/core';
import { StandardCareProposalDB } from 'src/app/common/repository/databases';
import { StandardCareProposalDto } from '../models/standard-careproposal/standard-careproposal-dto.model';
import { IQueryService } from './contracts/query/query-service';
import { QueryService } from './query/query.service';

@Injectable({
  providedIn: 'root',
})
export class StandardCareProposalService {
  constructor(@Inject(QueryService) private _queryService: IQueryService) {}

  public async loadStandardCareProposals(therapyId: number, therapyTypeId: number): Promise<IStandardCareProposal[]> {
    if (!therapyId || therapyTypeId === undefined || therapyTypeId === null) {
      return;
    }

    const standardCareProposals = await this._queryService.getAll<StandardCareProposalDto>(StandardCareProposalDB);
    const filteredStandardCareProposals = standardCareProposals
      .filter(
        standardCareProposal =>
          standardCareProposal.therapyId === therapyId &&
          standardCareProposal.therapyTypeIds &&
          standardCareProposal.therapyTypeIds.some(therapyType => therapyType === therapyTypeId) &&
          !standardCareProposal.archived
      )
      .sort((standardCareProposalA, standardCareProposalB) =>
        standardCareProposalA.name.localeCompare(standardCareProposalB.name, 'de', { sensitivity: 'base' })
      ) as IStandardCareProposal[];

    return filteredStandardCareProposals;
  }

  public async getByIds(ids: string[]): Promise<StandardCareProposalDto[]> {
    if (ids?.length) {
      return await this._queryService.search<StandardCareProposalDto>(
        { query: ids.map(id => `_id:${id}`).join(' ') },
        StandardCareProposalDB,
        { isIn: true }
      );
    }

    return [];
  }
}
